import Notice from '@/util/notice.base';

export default (
    message: string,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    callback: () => void = (): void => {},
    title: string = WordList.ListWarning
) => {
    Notice.messageBox('confirm', message, title, 'warning')(callback);
};